//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import // XButton,
// XInput,
"vux";
import { mapState } from "vuex";
import { Toast, Dialog } from "vant";
import { service, nativeApi } from "@/common/index";
import { fetch } from "@/page/index";
import VueFileUpload from "vue-file-upload";
import SrmCommonUtils from "@/utils/SrmCommonUtils"

export default {
  data() {
    return {
      pendingList: [],

      /** 刷新用变量 */
      pageIndex: 1,
      pageRows: 10,
      refreshing: true,
      finished: false,
      loading: false,
    };
  },
  components: {
    VueFileUpload,
  },
  computed: {
    ...mapState({
      userInfo: (state) => state.user.userInfo,
      languageCode: (state) => state.user.languageCode,
    }),
  },
  created() {
    this.requestQuotes();
  },
  activated: function () {},
  methods: {
    onRefresh() {
      //状态设置
      this.refreshing = true;
      this.loading = false;
      this.finished = false;
      //页数设置
      this.pageIndex = 1;
      this.onLoad();
    },
    onLoad() {
      this.requestQuotes();
    },
    requestQuotes() {
      fetch
        .srmMobileSupplierPendingRestful_listByPage({
          lan: this.languageCode,
          pageIndex: this.pageIndex, //页数
          pageRows: this.pageRows,
          supplierId:this.userInfo.supplierId,
          handleFlag: "N",
          cancelFlag: "N"
        })
        .then((res) => {
          //状态设置
          this.refreshing = false;
          this.loading = false;
          if (res.status === "S") {
            if (res.code === "S") {
              //清楚最后多余的数据
              const curPageIndex = res.page.curIndex; //页数
              const curIndex = (curPageIndex - 1) * this.pageRows; //index
              const lastLength = this.pendingList.length - curIndex; //剩余长度
              this.pendingList.splice(curIndex, lastLength);

              this.pendingList = this.pendingList.concat(res.data); //拼接数据
              if (res.data.length >= this.pageRows) {
                this.pageIndex = res.page.nextIndex; //更新页数
              } else {
                //数据length不足row，没有更多数据，不继续往后加载
                this.finished = true;
              }
            }
          }
        });
    },
    getLookupValuesMeaning(lookupType, lookupValue) {
      const _this = this
      return new SrmCommonUtils(_this).getLookupMeaning(lookupType, lookupValue)
    }
  },
  watch: {},
  mounted() {},
};



// WEBPACK FOOTER //
// ./src/page/srm/pending/supplierPendingList.vue